import { MatchGroupScore } from "./talentsTypes";

export const MATCH_GROUP_LABELS: Record<string, string> = {
  physical_conditions: "Physical Conditions",
  employment_profile: "Preferences",
  technical_skills: "Technical Fit",
  rewards_expectations: "Expectations",
  organizational_fit: "Organisational Fit",
};

export const MATCH_GROUP_ORDER = [
  "employment_profile",
  "physical_conditions",
  "organizational_fit",
  "rewards_expectations",
  "technical_skills",
] as const;

export const MATCH_FIELD_LABELS: Record<string, string> = {
  physicalConditions: "Physical Conditions",
  workHoursArrangement: "Work Hours Arrangement",
  workingMethod: "Working Method",
  countryEligibility: "Country Eligibility",
  companySize: "Company Size",
  sectors: "Sectors",
  typeOfPosition: "Type of Position",
  companyType: "Company Type",
  priorities: "Priorities",
  seniorityLevel: "Seniority Level",
  hiringUrgency: "Hiring Urgency",
  skills: "Skills",
  benefits: "Benefits",
  careerOpportunities: "Career Opportunities",
  salaryExpectation: "Salary Expectation",
  trainingOpportunities: "Training Opportunities",
  leadershipPerspective: "Leadership Perspective",
  organisationBonds: "Organisation Bonds",
  organisationDefinition: "Organisation Definition",
  organisationStructure: "Organisation Structure",
  organisationValues: "Organisation Values",
  successFactors: "Success Factors",
  teamWork: "Team Work",
};

const toTitleCase = (value: string) => {
  if (!value) return value;
  const spaced = value
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2");
  return spaced
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const formatGroupLabel = (groupName: string) => {
  return MATCH_GROUP_LABELS[groupName] ?? toTitleCase(groupName);
};

export const formatFieldLabel = (fieldName: string) => {
  return MATCH_FIELD_LABELS[fieldName] ?? toTitleCase(fieldName);
};

export const sortGroupScores = (groupScores: MatchGroupScore[]) => {
  const order = new Map(MATCH_GROUP_ORDER.map((key, index) => [key, index]));
  return [...groupScores].sort((a, b) => {
    const aOrder =
      order.get(a.groupName as (typeof MATCH_GROUP_ORDER)[number]) ??
      Number.MAX_SAFE_INTEGER;
    const bOrder =
      order.get(b.groupName as (typeof MATCH_GROUP_ORDER)[number]) ??
      Number.MAX_SAFE_INTEGER;
    return aOrder - bOrder;
  });
};

export const buildRadarData = (groupScores: MatchGroupScore[]) => {
  const byName = new Map(groupScores.map((group) => [group.groupName, group]));
  return MATCH_GROUP_ORDER.map((groupKey) => ({
    subject: formatGroupLabel(groupKey),
    A: Math.round(byName.get(groupKey)?.weightedAverage ?? 0),
  }));
};
